import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import GoodsOrder from "@com/order/GoodsOrder.vue";
export default {
  __name: 'GoodsOrder',

  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_main = _resolveComponent("el-main");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createVNode(GoodsOrder, {
          type: "order",
          routeName: "goodsorder"
        })]),
        _: 1
      })]);
    };
  }

};